import { render, staticRenderFns } from "./DownloadAttributesDialog.vue?vue&type=template&id=0a0dff03&scoped=true&"
import script from "./DownloadAttributesDialog.vue?vue&type=script&lang=js&"
export * from "./DownloadAttributesDialog.vue?vue&type=script&lang=js&"
import style0 from "./DownloadAttributesDialog.vue?vue&type=style&index=0&id=0a0dff03&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a0dff03",
  null
  
)

export default component.exports